var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6646 11.528C9.80406 9.23963 6.32863 5.77534 4 1.11795L6.23608 -5.86617e-05C8.34873 4.22537 11.5352 7.42299 14.2263 9.57582C15.5674 10.6487 16.7732 11.4523 17.6397 11.9855C18.0725 12.2519 18.4197 12.4501 18.6553 12.5801C18.7731 12.6451 18.863 12.693 18.9217 12.7238C18.951 12.7392 18.9726 12.7503 18.9859 12.7571L18.9997 12.7641L19.0009 12.7647L19.0014 12.765C19.0014 12.765 19.0014 12.765 19.0009 12.7659L19.0009 14.9996C19.0014 15.0006 19.0014 15.0005 19.0014 15.0005L19.0009 15.0008L18.9997 15.0014L18.9859 15.0084C18.9726 15.0152 18.9511 15.0264 18.9217 15.0417C18.863 15.0725 18.7732 15.1204 18.6554 15.1854C18.4197 15.3155 18.0726 15.5137 17.6397 15.7801C16.7732 16.3133 15.5674 17.1169 14.2263 18.1898C11.5352 20.3427 8.34873 23.5404 6.23608 27.7659L4 26.6479C6.32862 21.9905 9.80405 18.5261 12.6646 16.2377C13.9184 15.2346 15.0635 14.4499 15.9583 13.8828C15.0635 13.3157 13.9184 12.531 12.6646 11.528Z",
    fill: "#00AFEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.2236c628293a5b2e74dbd3f5ab63ed47.svg";
export { ForwardRef as ReactComponent };